import { useHasLicensedFeature } from 'react-common'
import { useTranslation } from 'react-i18next'
import { isOpenCatalog } from '@/utils/isOpenCatalog'

// it is a dummy hook that always returns false, because in open-catalog page we don't have access to the license features
const useDummyHook = () => false

const APBundle = 'LMS.APBundle'

export const useCoursesTitle = () => {
  const { t } = useTranslation()

  const isOpenCatalogPage = isOpenCatalog()

  const hook = isOpenCatalogPage ? useDummyHook : useHasLicensedFeature
  const hasAPBundle = hook([APBundle])

  const title = hasAPBundle ? t('quizzesList.heading') : t('coursesList.heading')

  return title
}
